import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app-routing.module';
import { getAuthUserUrl } from './apiKeys';
import { AUTH_CONFIG, BffUserService } from '@canvas/four-r-digital';
import { environment } from '../environments/environment';
import { DialogModule } from '@angular/cdk/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: AUTH_CONFIG, useValue: { authUrl: getAuthUserUrl() } },
    BffUserService,
    importProvidersFrom(DialogModule, NgxSpinnerModule),
  ],
};
